import Vue from "vue";
import { HelperFunctions } from "@/services/helper-functions";

Vue.filter("displayDate", (value: any, type: number) => {
  if (!value) return 0;
  return HelperFunctions.displayDate(value, type);
});

Vue.filter("displayTime", (value: any) => {
  if (!value) return "";
  return new Date(value).toISOString().substring(11, 19);
});
